<template>
  <div class="mobile-header">
    <div class="header-left">
      <span class="menu-icon" @click="$emit('open-sidebar')">☰</span>
      <div class="logo">
        <span class="logo-badge">微</span>
        <span class="logo-text">我的控制台</span>
      </div>
    </div>
    <div class="header-right">
      <UserInfo :compact="true" :user-name="userName" avatar-text="A" />
    </div>
  </div>
</template>

<script setup>
import UserInfo from '@/components/comm/UserInfo.vue'

defineProps({
  userName: {
    type: String,
    default: 'admin'
  }
})

defineEmits(['open-sidebar'])
</script>

<style scoped>
.mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: white;
  border-bottom: 1px solid #e0ecff;
  position: sticky;
  top: 0;
  z-index: 90;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.menu-icon {
  font-size: 1.5rem;
  color: #0066cc;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f0f7ff;
}

.logo {
  display: flex;
  align-items: center;
  gap: 6px;
}

.logo-badge {
  background: #0066cc;
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
}

.logo-text {
  font-weight: 600;
  color: #00377a;
  font-size: 0.95rem;
}
</style>